import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  container: {
    height: "calc(100% - 90px)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    height: 40,
  },
  tableContainer: {
    height: "calc(100% - 40px)",
    width: "100%",
  },
}));